<template>
  <div class="modal-content">
    <form
      class="attachment-edit-form"
      autocomplete="off"
    >
      <div>
        <p class="attachment-info">
          <span class="bold">{{ local.attachments.attachmentName }}:</span>
          {{ attachment.name }}
        </p>

        <p
          v-if="attachment.categoryName"
          class="attachment-info"
        >
          <span class="bold">{{ local.attachments.attachmentType }}:</span>
          {{ attachment.categoryName }}
        </p>

        <p
          v-if="attachment.description"
          class="attachment-info"
        >
          <span class="bold">{{ local.attachments.description }}:</span>
          {{ attachment.description }}
        </p>

        <p
          v-if="attachment.acceptanceCriteria"
          class="attachment-info"
        >
          <span class="bold">{{ local.attachments.acceptanceCriteria }}:</span>
          {{ attachment.acceptanceCriteria }}
        </p>

        <template v-if="attachment.sampleImageDownloadBase64">
          <p class="attachment-info">
            <span class="bold">{{ local.attachments.sampleImage }}:</span>
          </p>

          <img
            class="attachment-sample-image"
            :src="`data:image/png;base64,${attachment.sampleImageDownloadBase64}`"
          >
        </template>

        <naj-button
          v-if="false"
          class="action"
        >
          {{
            local.attachments.updateImageRotation
          }}
        </naj-button>
      </div>
    </form>

    <div
      v-if="loading"
      class="loader-holder"
    >
      <naj-loader></naj-loader>
    </div>
    <template v-else>
      <div
        v-if="attachment"
        :class="['attachment-file-viewer', isImage ? 'image-file' : 'pdf-file']"
      >
        <button
          text
          class="full-screen-button"
          @click="$emit('showFullScreen')"
        >
          <v-icon class="icon">
            mdi-arrow-expand
          </v-icon>
        </button>
        <image-editor
          v-if="isImage"
          :image-url="fileUrl"
          :image-name="attachment.name"
          @updateImage="updateImageUrl"
        ></image-editor>
        <!-- :preview-mode="true" -->

        <div
          v-else
          class="pdf-container"
        >
          <div class="pdf-wrapper">
            <div class="pdf-holder">
              <embed
                class="pdf-viewer"
                :src="fileUrl"
              >
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ImageEditor from './image-editor';
import { getBlobUrl } from '@/modules/lawsuit/helpers/utils';
export default {
  components: { ImageEditor },
  props: {
    isImage: {
      type: Boolean,
      required: false,
      default: true,
    },
    attachment: {
      type: Object,
      required: true,
    },
  },
  data () {
    return { loading: !this.attachment.fileUrl };
  },
  computed: {
    fileUrl () {
      return getBlobUrl(this.attachment.fileUrl, this.isImage);
    },
  },
  watch: {
    fileUrl (newValue) {
      this.loading = !newValue;
    },
  },
  methods: {
    updateImageUrl (imageUrl) {
      this.attachment.fileUrl = imageUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
.attachment-file-viewer {
  width: 100%;
  height: 608px;
}
.preview-holder {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
}
.rotate-actions {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 56px;
  margin-top: 65px;
  position: relative;
  z-index: 56;

  .action {
    width: calc(50% - 2px);
    height: 54px;
    margin-top: 2px;
    background-color: #f1f2f6;
    color: #000000;
    text-align: center;
    &:hover {
      background-color: #eee;
    }
    &.v-icon.v-icon::after {
      content: none;
    }
  }
}
.pdf-container {
  height: 100%;
  .pdf-wrapper {
    height: 100%;
    position: relative;
    min-height: 150px;
    .pdf-holder {
      height: inherit;
      text-align: center;
      line-height: 1;
      .pdf-viewer {
        height: 100%;
        width: 100%;
        display: inline-block;
      }
    }
  }
}

.attachment-sample-image{
  width: 50%;
  height: auto;
  display: block;
}
</style>